// extracted by mini-css-extract-plugin
module.exports = {"title":"_02712f2b3b--title--ARRNf","row":"_02712f2b3b--row--toLeq","key":"_02712f2b3b--key--aIKBJ","value":"_02712f2b3b--value--BEho1","warning":"_02712f2b3b--warning--nsFvl"};